import NewsService from '../../services/news.service';
import models_V2Service from '../../services/models_V2.service';

const getNewsSource = role_id => {
    const isSuperAdmin = role_id === 1;

    return {
        getData: (page, size, sort, filter) =>
            isSuperAdmin
                ? NewsService.GetAllNewsAdmin(false, {
                      page: page || 0,
                      size: size || 10,
                      orderBy: (sort && sort.orderBy) || null,
                      order: (sort && sort.order) || 'asc',
                      filter,
                  })
                : NewsService.GetAllNewsBoss(false, {
                      page: page || 0,
                      size: size || 10,
                      orderBy: (sort && sort.orderBy) || null,
                      order: (sort && sort.order) || 'asc',
                      filter,
                  }),

        getModel: () => (isSuperAdmin ? models_V2Service.getNewsAdmin() : models_V2Service.getNewsBoss()),
    };
};

export { getNewsSource };
